import { flow } from 'fp-ts/function';
import getValidUrl from './getValidUrl';
import optionalAtob from './optionalAtob';

const decodeBase64Url = flow(optionalAtob, (url) => (url ? getValidUrl(url) : null));

export default decodeBase64Url;
